import React from 'react';
import { content, SupportedLocale } from '../lib/content';

type AboutProfessionalProps = {
  locale?: SupportedLocale;
};

export const AboutProfessional: React.FC<AboutProfessionalProps> = ({
  locale = 'pl',
}) => {
  const t = content[locale].aboutProfessional;

  return (
    <section id={t.id} className="about-professional reveal">
      <div className="container about-grid">
        <div className="about-text">
          <div className="section-heading">
            <h2>{t.title}</h2>
          </div>
          {t.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
          <a className="inline-link" href={t.blogCtaLink} target="_blank" rel="noreferrer">
            {t.blogCtaText}
          </a>
        </div>
        <div className="about-portrait">
          <div className="portrait-accent" aria-hidden="true" />
          <img
            src="/Photo.png"
            alt={
              locale === 'en'
                ? 'Attorney Piotr Pieńkowski – portrait in the About section'
                : locale === 'es'
                ? 'Abogado Piotr Pieńkowski – retrato en la sección Sobre mí'
                : 'Adwokat Piotr Pieńkowski – portret w sekcji O mnie'
            }
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};
